import React from 'react';
import { useInView } from 'react-intersection-observer';
import { ExternalLink } from 'lucide-react';
import { useSectionData } from '../hooks/useSectionData';
import { fetchCertificates, attr } from '../services/api';

function fmtDate(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
}

export default function Certificates() {
  const items = useSectionData(fetchCertificates);
  const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true });

  if (!items) return null;

  return (
    <section id="certificates" ref={ref} className={`section${inView ? ' visible' : ''}`}>
      <div className="container">
        <header className="section-header">
          <p className="section-label">certificates</p>
          <h2 className="section-title">Certifications</h2>
          <div className="section-line" />
        </header>

        <div className="certs-grid">
          {items.map((item, i) => {
            const a = attr(item);
            return (
              <div key={i} className="cert-card">
                <p className="cert-name">{a.name}</p>
                <p className="cert-issuer">{a.issuer}</p>
                <div className="cert-meta">
                  {a.issue_date && <span>Issued {fmtDate(a.issue_date)}</span>}
                  {a.expiry_date && <span>· Expires {fmtDate(a.expiry_date)}</span>}
                  {a.credential_id && <span>ID: {a.credential_id}</span>}
                </div>
                {a.credential_url && (
                  <a
                    href={a.credential_url}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="cert-link"
                  >
                    <ExternalLink size={12} /> View Credential
                  </a>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
